import {IEntityAction, ActionMeta} from 'app/blocks/store/actions/entity-actions';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {IMposfile} from 'app/blocks/model/mpos-file.model';
import {IIncomingInventory} from 'app/blocks/model/inventory-movement.model';

export interface ICreateIncomingInventory extends IEntityAction {
    entity?: IIncomingInventory;
    uploadDocuments?: IMposfile[];
    deletedDocuments?: IMposfile[];
}

export interface IUpdateIncomingInventory extends IEntityAction {
    entity?: IIncomingInventory;
    uploadDocuments?: IMposfile[];
    deletedDocuments?: IMposfile[];
}

export class CreateIncomingInventory implements ICreateIncomingInventory {
    static readonly type = '[Incoming Inventory] Create Incoming Inventory';
    constructor(
        public resource: AbstractEntityResource<any>,
        public entity: IIncomingInventory,
        public uploadDocuments?: IMposfile[],
        meta?: ActionMeta
    ) {}
}

export class UpdateIncomingInventory implements IUpdateIncomingInventory {
    static readonly type = '[Incoming Inventory] Update Incoming Inventory';
    constructor(
        public resource: AbstractEntityResource<any>,
        public entity: IIncomingInventory,
        public uploadDocuments?: IMposfile[],
        public deletedDocuments?: IMposfile[],
        meta?: ActionMeta
    ) {}
}
